import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Copyright = () => {
  return (
    <Container className="footer-copy text-white">
      <Row>
        <Col>
          <div className="d-flex py-3 justify-content-between ">
            <p>&copy; 2017 DesignGalaxy8. All rights reserved.</p>
            <div className="copy-menu">
              <span>Privacy policy</span>
              <span>Terms of use</span>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Copyright;
